import { deferTracking, sendGAEvent } from '@noths/polaris-client-google-analytics';

export const trackOpenContactPartnerModal = (partnerName: string) => {
  deferTracking(() =>
    sendGAEvent({
      event: 'custom_event',
      event_action: 'Click',
      event_category: 'Contact seller',
      event_label: partnerName,
    }),
  );
};

export const trackCloseContactPartnerModal = (partnerName: string) => {
  deferTracking(() =>
    sendGAEvent({
      event: 'custom_event',
      event_action: 'Close',
      event_category: 'Contact seller',
      event_label: partnerName,
    }),
  );
};

export const trackContactPartnerSubmitFulfilled = (partnerName: string) => {
  deferTracking(() =>
    sendGAEvent({
      event: 'custom_event',
      event_action: 'Submit',
      event_category: 'Contact seller',
      event_label: partnerName,
    }),
  );
};

export const trackContactPartnerValidationError = (error: string) => {
  deferTracking(() =>
    sendGAEvent({
      event: 'custom_event',
      event_action: 'Error',
      event_category: 'Contact seller',
      event_label: error,
    }),
  );
};

export const trackSubmitMarketingPreferences = (email: string) => {
  deferTracking(() =>
    sendGAEvent({
      event: 'custom_event',
      event_category: 'Marketing preferences',
      event_action: 'Subscribe',
      event_label: 'Contact seller',
      user_email: email,
    }),
  );
};

export const trackMarketingPreferencesImpression = () => {
  deferTracking(() =>
    sendGAEvent({
      event: 'custom_event',
      event_category: 'Marketing preferences',
      event_action: 'Impression',
      event_label: 'Contact seller',
    }),
  );
};
